"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _stream = require("stream");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ConsolaWriteStream = /*#__PURE__*/function (_Writable) {
  _inherits(ConsolaWriteStream, _Writable);

  var _super = _createSuper(ConsolaWriteStream);

  function ConsolaWriteStream(_ref) {
    var _this;

    var logger = _ref.logger,
        type = _ref.type,
        options = _objectWithoutProperties(_ref, ["logger", "type"]);

    _classCallCheck(this, ConsolaWriteStream);

    _this = _super.call(this, options);
    _this.logger = logger;
    _this.type = type;
    return _this;
  } // eslint-disable-next-line no-underscore-dangle


  _createClass(ConsolaWriteStream, [{
    key: "_write",
    value: function _write(chunk, encoding, callback) {
      var logItem = Buffer.from(chunk, encoding).toString().slice(0, -1); // trim trailing newline

      try {
        logItem = JSON.parse(logItem);
      } catch (err) {// Was not JSON, continue logging as a string (for dev mode)
      }

      try {
        this.logger[this.type]('', logItem);
      } catch (err) {
        callback(err);
      }

      callback();
    }
  }]);

  return ConsolaWriteStream;
}(_stream.Writable);
/**
 * Setup access logs for Express applications.
 */


var setupAccessLogs = function setupAccessLogs(app, logger) {
  var morgan = require('morgan'); // eslint-disable-line


  var isDev = process.env.NODE_ENV !== 'production';
  var devFormatter = 'dev'; // Format logs for DataDog

  var prodFormatter = function prodFormatter(tokens, req, res) {
    var _req$headers$host$spl = req.headers.host.split(':'),
        _req$headers$host$spl2 = _slicedToArray(_req$headers$host$spl, 2),
        host = _req$headers$host$spl2[0],
        port = _req$headers$host$spl2[1];

    var url = new URL("".concat(req.protocol, "://").concat(host || req.hostname).concat(port ? ":".concat(port) : '').concat(req.originalUrl));
    return JSON.stringify({
      duration: tokens['total-time'](req, res) * 1000000,
      // Convert ms to ns
      http: {
        url: url.href,
        status_code: Number(tokens.status(req, res)),
        method: tokens.method(req, res),
        referer: tokens.referrer(req, res),
        useragent: tokens['user-agent'](req, res),
        version: tokens['http-version'](req, res),
        headers: req.headers,
        url_details: {
          host: url.hostname,
          port: url.port,
          path: url.pathname,
          scheme: url.protocol.replace(':', '')
        }
      },
      network: {
        client: {
          ip: tokens['remote-addr'](req, res)
        }
      }
    });
  };

  app.use(morgan(isDev ? devFormatter : prodFormatter, {
    stream: new ConsolaWriteStream({
      logger: logger,
      type: 'debug'
    })
  }));
};

var _default = setupAccessLogs;
exports["default"] = _default;